import { render, staticRenderFns } from "./Regulations.vue?vue&type=template&id=4ca2a93e&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2a93e",
  null
  
)

export default component.exports